import React from "react";
import { createUseStyles } from "react-jss";
import { Link } from "react-router-dom";

const useStyles = createUseStyles(theme => ({
  container: {
    width: 250,
    height: 250,
    "border-radius": 8,
    "background-color": props => (props.loading ? "#3e3e3e" : "#252525"),
    "background-size": "auto 120%",
    "background-position": "center",
    "background-image": props => (props.image ? `url("${props.image}")` : ""),
    transition: "background-size 0.3s ease",
    margin: [0, 15, 15, 0],
    position: "relative",
    overflow: "hidden",

    "@media (max-width: 800px)": {
      width: 200,
      height: 200,
    },

    "&:hover": {
      "background-size": "auto 130%",
      "& $text": {
        opacity: 0.2,
      },
      "& $overlay, $overlay > a": {
        opacity: 1,
      },
    },
  },
  text: {
    position: "absolute",
    width: "100%",
    bottom: 0,
    padding: [5, 10],
    opacity: 1,
    transition: "opacity 0.2s ease",
    "box-sizing": "border-box",
    "pointer-events": "none",
  },
  title: {
    color: "white",
    "font-size": 20,
    "text-align": "right",
    margin: 0,
  },
  token: {
    color: "white",
    margin: 0,
    opacity: "80%",
    "font-size": 16,
    "text-align": "right",
  },
  overlay: {
    width: "100%",
    height: "100%",
    "background-color": "rgba(0, 0, 0, 0.8)",
    opacity: 0.5,
    transition: "opacity 0.3s ease",
    display: "flex",
    "flex-direction": "column",
    "justify-content": "center",
    "align-items": "center",
    "border-radius": 8,

    "& a": {
      width: "70%",
      padding: [10],
      "background-color": "rgba(255, 255, 255, 0.3)",
      border: "none",
      color: "white",
      opacity: 0,
      transition: "0.2s ease",
      "transition-property": "opacity, background-color",
      margin: [15, 0],
      cursor: "pointer",
      "border-radius": 3,
      display: "block",
      "text-decoration": "none",
      "text-align": "center",

      "&:hover": {
        "background-color": theme.colorRed,
      },
    },
  },
}));

const Tour = ({ tour, loading }) => {
  const classes = useStyles({
    loading,
    image: tour.thumbnail,
  });

  return (
    <div className={classes.container}>
      {!loading && (
        <>
          <div className={classes.overlay}>
            <Link
              to={`/tour/${tour.token}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              VIEW
            </Link>
            <Link to={`/editor/${tour.token}`}>EDIT</Link>
          </div>
          <div className={classes.text}>
            <p className={classes.title}>{tour.title}</p>
            <p className={classes.token}>{tour.token}</p>
          </div>
        </>
      )}
    </div>
  );
};

export default Tour;
